module.exports = __webpack_public_path__ + "media/dpanthenol-small.5ffa25e1.mp4";